import Head from "next/head";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";

import UpsUSMain from "@/components/fulfilment-partners/ups-usa-main";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";
import { GetStaticProps } from "next";

export default function UPSUSA({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <UpsUSMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_UPS_USA },
  };
};
